import axios from './interceptor';

const URL = `${process.env.REACT_APP_BASE_URL}/itinerary-cards`;

export async function createItineraryCard(payload) {
    const response = await axios.post(`${URL}/create`, payload);
    return response.data;
}

export async function getAllItineraryCards() {
    const response = await axios.get(`${URL}/get-all`);
    return response.data;
}

export async function updateItineraryCard(id, payload) {
    const response = await axios.put(`${URL}/update/${id}`, payload);
    return response.data;
}

export async function deleteItineraryCard(id) {
    const response = await axios.delete(`${URL}/delete/${id}`);
    return response.data;
}
